export enum SatisfactionRateAnswerCategory {
    None = 0,
    Negative = 1,
    Neutral = 2,
    Positive = 3
}
